import styled from '@emotion/styled';

import { Container, TextBlockWithAside, TextBlockWithQuotes } from '@features';
import { getFont } from '@styles/mixins/fonts';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';
import { sectionGridTemplateBase } from '@styles/mixins/sectionGridTemplate';

export const StyledContainer = styled(Container)`
  --title-parts-margin: 0px;

  grid-template-areas:
    'first-title-part  first-title-part'
    'second-title-part second-title-part'
    'text-block        quote';
  padding-bottom: 475px;

  ${sectionGridTemplateBase}

  ${getMediaqueryStyled('xl')} {
    --title-parts-margin: 10px;

    padding-bottom: 420px;
  }

  ${getMediaqueryStyled('lg')} {
    --title-parts-margin: 0px;

    padding-bottom: 220px;
  }

  ${getMediaqueryStyled('md')} {
    grid-template-areas: 'first-title-part' 'second-title-part' 'quote' 'text-block';

    padding-bottom: 280px;
  }

  ${getMediaqueryStyled('sm')} {
    padding-bottom: 225px;
  }
`;

const TitlePart = styled.span`
  ${getFont('title')}
`;

export const TitlePartTop = styled(TitlePart)`
  grid-area: first-title-part;
  justify-self: end;
  margin-right: 165px;
  margin-bottom: var(--title-parts-margin);

  ${getMediaqueryStyled('xl')} {
    margin-right: 55px;
  }

  ${getMediaqueryStyled('lg')} {
    margin-right: 85px;
  }

  ${getMediaqueryStyled('md')} {
    margin-right: 35px;
  }

  ${getMediaqueryStyled('sm')} {
    margin-right: 0;
    /* max-width: 312px; */
    overflow-wrap: break-word;
  }
`;

export const TitlePartTopMobile = styled.span`
  display: none;

  ${getMediaqueryStyled('sm')} {
    display: inline;
  }
`;

export const TitlePartBottom = styled(TitlePart)`
  grid-area: second-title-part;
  justify-self: end;
  margin-bottom: 35px;

  ${getMediaqueryStyled('xl')} {
    margin-bottom: 45px;
  }

  ${getMediaqueryStyled('lg')} {
    margin-bottom: 40px;
  }
`;

export const TitlePartBottomNotMobile = styled.span`
  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const Quote = styled(TextBlockWithQuotes)`
  grid-area: quote;

  ${getMediaqueryStyled('md')} {
    margin-bottom: 40px;
  }
`;

export const TextBlock = styled(TextBlockWithAside)`
  grid-area: text-block;
  margin-top: 75px;

  ${getMediaqueryStyled('xl')} {
    margin-top: 55px;
  }
  ${getMediaqueryStyled('lg')} {
    margin-top: 35px;
  }

  ${getMediaqueryStyled('md')} {
    margin-top: 0;
  }
`;

export const Subtitle = styled.h3`
  margin: 0;
  ${getFont('subtitle')}

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;
